import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../lib/redux/hooks";
import { colors } from "../../ui/color";
import { EditIcon } from "../../ui/icons/editIcon";
import { ReportIcon } from "../../ui/icons/reportIcon";
import { Layout } from "../../ui/layout";
import Button from "../../ui/molecoles/button";
import { ErrorPopup } from "../../ui/organisms/errorPopup";
import { MenuItems } from "../../ui/organisms/navbar/dto";
import { Pagination } from "../../ui/organisms/pagination";
import { SuccessPopup } from "../../ui/organisms/successPopup";
import { ReportFilter } from "./filters";
import { ReportList } from "./list";
import { NewReportModal } from "./newReportModal";
import { findAllReport, setCreateReportStatus, setDeleteReportStatus, setOpenNewReportModal, setReportFilterPage } from "./slice";

export function Report() {
    const navigation = useNavigate()
    const dispatch = useAppDispatch()

    const reportState = useAppSelector(state => state.report)

    useEffect(() => {
        dispatch(findAllReport(reportState.findAllFilters))
    }, [reportState.findAllFilters.page])

    return (
        <Layout
            breadcrumbItems={['Report']}
            menuItem={MenuItems.REPORT}
            headingLabel={"Report"}
            headingButtons={[
                <Button
                    size={"sm"}
                    iconPosition={"left"}
                    variant={"solid"}
                    color={"blue"}
                    label="Create report"
                    icon={<EditIcon size={0} color={""} />}
                    onClick={() => dispatch(setOpenNewReportModal(true))}
                />
            ]}
            breadcrumbIcon={<ReportIcon size={20} color={colors.pas[500]} />}
        >
            <SuccessPopup
                active={reportState.createReportStatus === "successfully"}
                close={() => dispatch(setCreateReportStatus("idle"))}
                message="Report creato con successo"
            />
            <ErrorPopup
                active={reportState.createReportStatus === "failed"}
                close={() => dispatch(setCreateReportStatus("idle"))}
                message={reportState.createReportErrorMessage}
            />
            <SuccessPopup
                active={reportState.deleteReportStatus === "successfully"}
                close={() => dispatch(setDeleteReportStatus("idle"))}
                message="Report eliminato con successo"
            />
            <ErrorPopup
                active={reportState.deleteReportStatus === "failed"}
                close={() => dispatch(setDeleteReportStatus("idle"))}
                message="Errore nella eliminato del report"
            />
            <ReportFilter />
            <ReportList />
            {
                reportState.findAllResponse !== undefined &&
                reportState.findAllResponse.paginationData !== undefined &&
                reportState.findAllResponse.paginationData.totalPage > 0 &&
                <div className="flex bg-white drop-shadow-sm items-center justify-center p-2">
                    <Pagination
                        pages={reportState.findAllResponse.paginationData.totalPage || 1}
                        currentPage={reportState.findAllFilters.page}
                        setPage={(page) => dispatch(setReportFilterPage(page))}
                    />
                </div>
            }
            <NewReportModal />
        </Layout>

    )
}